import { defineComponent, computed } from "vue";
import { g as generateUniqueId } from "../../utils/uuid-7d2e5892.mjs";
import { u as useAlertStyles } from "./useAlertStyles-b9a8e487.mjs";
import { V as VaIcon } from "../va-icon/index-7fefcddb.mjs";
import { u as useStatefulEmits, a as useStatefulProps, b as useStateful } from "../../composables/useStateful-50e4a6b9.mjs";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
import { u as useTranslation } from "../../composables/useTranslation-67b81a6e.mjs";
const _sfc_main = defineComponent({
  name: "VaAlert",
  components: { VaIcon },
  emits: useStatefulEmits,
  props: {
    ...useStatefulProps,
    ...useComponentPresetProp,
    modelValue: { type: Boolean, default: true },
    color: { type: String, default: "primary" },
    textColor: { type: String, default: "" },
    title: { type: String, default: "" },
    description: { type: String, default: "" },
    icon: { type: String, default: "" },
    closeText: { type: String, default: "" },
    closeable: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    outline: { type: Boolean, default: false },
    center: { type: Boolean, default: false },
    borderColor: { type: String, default: "" },
    border: {
      type: String,
      default: "",
      validator: (value) => ["top", "right", "bottom", "left", ""].includes(value)
    }
  },
  setup(props, { slots, emit }) {
    const alertStyles = useAlertStyles(props);
    const { valueComputed } = useStateful(props, emit);
    const hide = () => {
      valueComputed.value = false;
    };
    const hasIcon = computed(() => props.icon || slots.icon);
    const hasTitle = computed(() => props.title || slots.title);
    const borderClass = computed(() => `va-alert__border--${props.border}`);
    const closeIcon = computed(() => props.closeText || "close");
    const uniqueId = computed(generateUniqueId);
    const titleIdComputed = computed(() => `aria-title-${uniqueId.value}`);
    const descriptionIdComputed = computed(() => `aria-description-${uniqueId.value}`);
    return {
      ...useTranslation(),
      ...alertStyles,
      valueComputed,
      hasIcon,
      hasTitle,
      borderClass,
      closeIcon,
      hide,
      titleIdComputed,
      descriptionIdComputed
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaAlert.vue_vue_type_script_lang-ad6495f7.mjs.map
